import { AddressLookupResponse, AddressVerdict, type AddressLookupRow } from '@bartizo/shared';
import { apiRequest } from './client.js';

/** An address's verdict and a list's badges (P11.1; section 15). */

export const getAddressVerdict = (ip: string): Promise<AddressVerdict> =>
  apiRequest(`/addresses/${encodeURIComponent(ip)}`, { schema: AddressVerdict });

export async function lookupAddresses(ips: readonly string[]): Promise<AddressLookupRow[]> {
  if (ips.length === 0) return [];
  const answer = await apiRequest('/addresses/lookup', {
    method: 'POST',
    body: { ips },
    schema: AddressLookupResponse,
  });
  return answer.addresses;
}
